// @ts-nocheck
import React from "react";
import { useLanguageContext } from "../context/languageContext";
import MenuImage from "./MenuImage";

/**
 * One dish, the way a printed menu line reads it: photo, name, price. Nothing to
 * tap - the app is a menu, not an ordering system.
 */
const ProductDetailCard = ({ product }) => {
    const { language } = useLanguageContext();

    const getTranslatedName = () => {
        if (!product?.itemTranslation) return product.name;
        const translations = product.itemTranslation;
        const map = { en: 'englishName', it: 'italianName', sq: 'albanianName', de: 'germanName', es: 'spanishName', pl: 'polishName', ukr: 'ukrainianName' };
        return translations[map[language]] || product.name;
    };

    return (
        <div className="group flex flex-col bg-white rounded-2xl border border-slate-50 transition-all duration-300 hover:border-brand-600/10 hover:shadow-[0_15px_30px_-10px_rgba(0,0,0,0.05)] overflow-hidden h-full">
            {/* Architectural Image Container */}
            <div className="relative w-full aspect-square bg-slate-50 overflow-hidden">
                <MenuImage
                    src={product.imageUrl}
                    alt={getTranslatedName()}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />

                {/* Price Pill: Sharp Styled */}
                <div className="absolute top-2.5 left-2.5 px-2 py-1 bg-white/95 backdrop-blur-md border border-black/[0.03] rounded-lg shadow-sm">
                    <p className="text-xs font-black text-slate-900 tracking-tight">{product.price} <span className="text-[9px] text-slate-400 uppercase">ALL</span></p>
                </div>
            </div>

            {/* Content: Space-Wise Precision */}
            <div className="p-3">
                <h2 className="text-m font-bold text-slate-900 leading-tight truncate">{getTranslatedName()}</h2>
            </div>
        </div>
    );
};

export default ProductDetailCard;
